import { useEffect, useRef } from "react";
import { LogOut } from "lucide-react";
import { AppearanceControls } from "./Appearance";
import { WallpaperSettings } from "./Wallpaper";

// iOS-style Settings sheet: Appearance (theme, glass effects), Wallpaper, Account. Sign out lives
// here, at the bottom, so it is never one stray click away; the caller confirms it first.
export function SettingsSheet({ open, onClose, effects, setEffects, wallpaper, account, onSignOut }) {
  const sheet = useRef(null), back = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    back.current = document.activeElement;
    sheet.current?.querySelector("button, [href], input")?.focus();
    const onKey = (e) => {
      if (e.key === "Escape" && !document.querySelector(".ios-alert-scrim")) { e.preventDefault(); onClose(); }
    };
    window.addEventListener("keydown", onKey);
    return () => { window.removeEventListener("keydown", onKey); back.current?.focus?.(); };
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div className="ios-scrim ios-settings-scrim" role="presentation" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <section ref={sheet} className="ios-sheet ios-settings" role="dialog" aria-modal="true" aria-labelledby="ios-settings-title">
        <header className="ios-settings-head">
          <h2 id="ios-settings-title">Settings</h2>
          <button type="button" className="ios-btn ios-btn-plain" onClick={onClose}>Done</button>
        </header>
        <div className="ios-settings-body">
          <h3 className="ios-group-header"><span>Appearance</span></h3>
          <div className="ios-group ios-settings-appearance"><AppearanceControls effects={effects} setEffects={setEffects} /></div>
          {wallpaper && <WallpaperSettings wallpaper={wallpaper} />}
          <h3 className="ios-group-header"><span>Account</span></h3>
          <div className="ios-group">
            {account && <div className="ios-row"><span className="ios-row-main"><span className="ios-row-title">{account.name}</span><span className="ios-row-sub">{account.detail}</span></span></div>}
            <button type="button" className="ios-row ios-settings-signout" onClick={onSignOut}>
              <LogOut size={18} aria-hidden="true" /> <span className="ios-row-title">Sign out</span>
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
